export function FullScreenLoader() {
  return (
    <div className="bg-background min-h-screen flex items-center justify-center" role="status" aria-live="polite">
      <img src="/logo-menlo-loading.svg" className="h-8" alt="" />
      <span className="sr-only">Carregando...</span>
    </div>
  );
}
